<template lang="pug">
  .app-input-file.is-flex.is-centered
    label.label(
      :for="id"
    )
      span.title {{ label }}
    input.input(
      type="file"
      :id="id"
      :name="id"
      :accept="accept"
      :required="required"
      :disabled="disabled"
      @input="onInput"
    )
    img.img(
      v-if="value"
      :src="url"
    )
</template>

<script>
export default {
  name: 'AppInputFile',
  components: {
    AppButton: () => import(/* webpackChunkName: "app-button" */ '@/components/AppButton.vue'),
    AppIcon: () => import(/* webpackChunkName: "app-icon" */ '@/components/AppIcon.vue'),
  },
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [File, Blob, String],
      default: null,
    },
    accept: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    url() {
      if (this.value) {
        if (typeof this.value === 'string') return this.value;
        return URL.createObjectURL(this.value);
      }
      return null;
    },
  },
  methods: {
    onInput(event) {
      this.$emit('input', event);
    },
    onDelete(event) {
      this.$emit('delete', event);
    },
  },
};
</script>

<style lang="stylus" scoped>
.app-input-file
  width 100%
  height 100%
  position relative

.input
  position absolute
  left 0
  bottom 0
  right 0
  top 0
  width 100%
  height 100%
  opacity 0
  cursor pointer
  z-index 4

.title
  font-size 1.5rem

.img
  position relative
  left 0
  bottom 0
  right 0
  top 0
  width 100%
  max-height: 100%;
  z-index 3

.label
  opacity 0.5
  font-family NunitoSans
  font-weight 600
  font-style italic
  font-stretch normal
  letter-spacing normal
  color #707070
  font-size: .25rem
  text-align center
  z-index 2
</style>
